import { sessionStore } from '@/lib/storage';

/**
 * `BootController`'s flag: '1' means "this tab has already booted this
 * session", and anything else sends the visitor back through boot → welcome.
 *
 * sessionStorage, not localStorage, on purpose: a reload in the same tab should
 * land straight on the desktop, but a brand-new tab is a brand-new visit.
 */
export const BOOTED_KEY = 'teonio.booted';

/**
 * Power the machine back on.
 *
 * `sessionStore` has no `remove()`, and it does not need one: the boot
 * controller only treats the literal '1' as "already booted", so writing
 * anything else is enough to arm the boot screen.
 *
 * `replace`, and to the bare path: a deep link left in the query string sets
 * `skip` on the boot controller, which would take the boot screen away again.
 */
export function reboot(): void {
  sessionStore.set(BOOTED_KEY, '0');
  window.location.replace(window.location.pathname);
}
